import {
  USER_PROFILE_FETCH_REQUEST,
  USER_PROFILE_FETCH_SUCCESS,
  USER_PROFILE_FETCH_FAILURE,
  UPDATE_USER_PROFILE_REQUEST,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAILURE,
  AUTH_SESSION_EXPIRED,
} from '../actions/profileAction';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export default function userProfileReducer(state = initialState, action) {
  switch (action.type) {
    case USER_PROFILE_FETCH_REQUEST:
    case UPDATE_USER_PROFILE_REQUEST:
      return { ...state, loading: true, error: null };

    case USER_PROFILE_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };

    case UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: { ...state.data, ...action.payload }, // <-- update data, not profile
      };

    case USER_PROFILE_FETCH_FAILURE:
    case UPDATE_USER_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case AUTH_SESSION_EXPIRED:
      return {
        ...state,
        loading: false,
        error: action.payload,
        sessionExpired: true,
      };

    default:
      return state;
  }
}